<template>
  <div class="is_headapp">
    <h1>Первичная приёмка</h1>
    <pre v-if="0">
      {{order}}
    </pre>
    <template v-if="success">
      <p style="font-weight: bold; color: green;">Статус заказа успешно изменён</p>
    </template>
    <template v-else>
      <template v-if="!order">
          <p>
            <b>Шаг1</b><br>
            Введите или отсканируйте код или номер заявки:
          </p>
          <v-text-field 
            v-model="value"
            autofocus
            @keyup.enter="scan_order"
            label="Введите код"
          />
      </template>
      <template v-if="order">
          <p>
            <a href="" @click.prevent="order=null; list=[]"><v-icon x-small>fa fa-arrow-left</v-icon> назад</a><br>
            <b>Шаг 2</b>
            <br>
            Вы отсканировали заявку №{{order.order_id}} от {{order.registered}} Теперь отсканируйте места:
          </p>
          <v-text-field 
            v-model="value"
            autofocus
            @keyup.enter="scan_box"
            label="Введите код"
          />
        
          <template v-if="list.length">
            <table class="tbl1">
              <tr class="h">
                <td><b>Номер места</b></td>
                <td><b>Код пломбы</b></td>
                <td><b>Описание</b></td>
                <td>&nbsp;</td>
              </tr>
              <tr v-for="(l,idx) in list">
                  <td>
                    №{{l.num_place}}
                    <div v-if="!l.id" style="color: red;">не было зарегистрировано ранее</div>
                  </td>
                  <td><v-text-field v-model="l.plomb_code" label="Код пломбы" /></td>
                  <td><v-textarea v-model="l.body" label="Описание" /></td>
                <td class="actions"><a href="" @click.prevent="delete_from_list(idx)"><v-icon small  color="primary" icon >delete</v-icon></a></td>
              </tr>
            </table>
            <div style="margin-top: 20px;">
              <v-btn @click="accept_all()">Принять</v-btn>
            </div>
            <p v-if="accept_all_error" style="font-weight: bold; color: red">{{accept_all_error}}</p> <!-- ошибка при подтверждении -->
          </template>    
      </template>

    </template>
<!--       <template v-else>
        <p>По коду: {{value}} ничего не найдено</p>
      </template> -->
      

    
<!--     <v-btn @click="sound_success">success</v-btn>
    <v-btn @click="sound_fail">fail</v-btn> -->
  </div>

</template>

<script>
import { fixBarcode} from '../js/fixBarcode.js';
export default {
  //name:'firstInitIM',
  data(){
    return {
      step:1, // 1--сканирование заявки, 2-сканирование и добавление места
      num:0, // для отложенного ajax-а
      value:'', // код для поиска
      order:null, // отсканированная заявка
      list:[ // сканированные box-ы
        /*{type:'order',id:1},
        {type:'box',num_place:'76176276', id:1},*/
      ],
      sounds: {
          success: null,
          fail: null,
      },
      success: false, // сообщение об успешном добавлении
      accept_all_error: '', // сообщение об ошибке при добавлении "пропикиваний"

    }
  },
  created(){
    let t=this
    t.sounds.success = new Audio('/delivery/success.ogg');
    t.sounds.fail = new Audio('/delivery/fail.ogg');
    // t.$nextTick(() => {
    //   t.$refs.barcodeInput.focus();
    // });
  },
  methods:{
    sound_success(){
      this.sounds.success.currentTime = 0; // Перемотка на начало, если звук уже играл
      this.sounds.success.play().catch(e => console.error("Ошибка воспроизведения:", e));
    },
    sound_fail(){
      this.sounds.fail.currentTime = 0; // Перемотка на начало, если звук уже играл
      this.sounds.fail.play().catch(e => console.error("Ошибка воспроизведения:", e));
    },
    delete_from_list(idx){
      // удаляет из списка позицию
      this.list.splice(idx,1)
    },

    scan_order(){
      let t=this
      t.value=t.value.replace(/\s+/,'').replace(/\s+$/,'')
      if(!t.value){
        return 
      }
      t.num++

      setTimeout(
        ()=>{
          t.num--
          if(!t.num){ // поиск 
            t.$http.post(BackendBase+'/delivery/first-app/scan-order',{
              value: t.value
            }).then(
              r=>{
                let d=r.data
                
                if(d.success){
                  t.value=''
                  if(d.order){
                    t.order=d.order
                    t.sound_success()
                  }
                  else{
                    t.sound_fail()
                  }
                }
              }
            )
          }
        },
        300
      )
    },
    scan_box(){
      let t=this
      t.value=t.value.replace(/\s+/,'').replace(/\s+$/,'')
      if(!t.value || !t.order){
        return 
      }
      t.num++

      setTimeout(
        ()=>{
          t.num--
          if(!t.num){ // поиск 
            t.$http.post(BackendBase+'/delivery/first-app/scan-box',{
              order_id: t.order.id,
              value: t.value
            }).then(
              r=>{
                let d=r.data
                
                if(d.success){
                  
                  if(d.box){ // место найдено
                    
                    t.list.push(d.box)
                    t.sound_success()
                  }
                  else{
                    //t.sound_fail()
                    // если место не найдено, добавляем его:
                    t.list.push({
                        'order_id':t.order.id,
                        'num_place':t.value,
                        'plomb_code':'',
                        'status_id': 0,
                        'office_id': 0
                    })

                  }
                  t.value=''
                }
              }
            )
          }
        },
        300
      )
    },
    accept_all(){ // отравляется в приёмку накликанный список
      let t=this

      if(t.list.length){
          t.$http.post(
            BackendBase+'/delivery/first-app/accept-boxes',
            {
              list:t.list,
              order_id: t.order.id
            }
          ).then(
            r=>{
              let d=r.data
              if(d.success){
                t.success=true
                setTimeout(
                  ()=>{
                    t.list=[]
                    t.order=null
                    t.success=false
                  },900
                )
              }
              else if(d.error){
                t.accept_all_error=d.error
                setTimeout(
                  ()=>{
                    t.accept_all_error=false
                  },900
                )
              }
            }
          )
      }
    },
  },
  watch:{
    value(){
      if(this.value){
        this.value=fixBarcode(this.value)
      }
    }
  }
}
</script>

<style scoped>
  .is_headapp {margin: 20px; max-width: 1400px;}
  .is_headapp h1 {margin-bottom: 20px;} 
  .order, .box {border: 1px solid gray; padding: 20px; margin-bottom: 20px; border-radius: 15px;  font-weight: bold;}
  .order {background-color: #3f674a;}
  .box {background-color: #71be86;}
  td.actions {width: 0px;}
</style>